export default "__VITE_ASSET__nTIi4TJ9__"